import router from '../router';
import { message } from 'ant-design-vue';

export const bridges = () => {
    return {

        /*
        
        웹 > 앱, 앱 > 웹 통신을 담당하는 메소드 모음.

        사용법:

        1. 본 파일 내 선언 및 메소드 구현
        2. App.vue > intBridges에서 window 객체에 바인딩
        3. 필요한 순간에 호출

        checkIsLoggedIn(웹 > 앱), requestLogoutFromApp(앱 > 웹)
        전체검색 하시면 실사용 코드를 확인할 수 있습니다.
        
        */



        /*
        
        웹에서 앱 쪽으로 송신하는 유형의 메소드(이하 webToApp)
        
        */
        webToApp: (data) => {
            const userAgent = navigator.userAgent.toLowerCase();
            console.log(`webToApp, 디바이스: ${userAgent}, 수신 값: ${JSON.stringify(data)}`)
            if (userAgent.indexOf('android') !== -1) {
                //안드로이드
                if (typeof WebViewBridge !== 'undefined' && WebViewBridge) {
                    if(WebViewBridge) WebViewBridge?.webToApp(data);
                } else {
                    console.log('WebViewBridge does not exist');
                }
            } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
                // ios
                if (window.webkit?.messageHandlers && window.webkit?.messageHandlers?.webToApp) {
                    window.webkit.messageHandlers.webToApp.postMessage(data);
                }
            } else { 
                //기타
                window.opener?.postMessage(data);
            }
        },
        /*
        
        앱에서 웹 쪽으로 송신(이하 appToWeb)
        
        */
        appToWeb: (input) => {
            console.log(`appToWeb, 수신 파라미터: ${input}`)
            const obj = {};
            const newInput = JSON.stringify(input)
            if(newInput && typeof newInput.accessToken !== 'undefined') {
                localStorage.setItem('accessTokenManu', newInput.accessToken);
            }
            if(newInput && typeof newInput.refreshToken !== 'undefined') {
                localStorage.setItem('accessTokenManu', newInput.refreshToken);
            }
        },
        /*
        
        앱에서 로그아웃 요청(appToWeb)
        
        */
        requestLogoutFromApp: () => {
            console.log(`requestLogoutFromApp`)
            // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-STORE-HYGIENE-001 — dead localStorage 키 제거
            //   nameManu/managerManu/companyManu/companyImageUrlManu는 getItem 0건 dead.
            //   setItem도 actions.setUserInfo(외부 호출 0)에서만 발생했음. removeItem만 남아있던 잔재.
            localStorage.removeItem('accessTokenManu');
            localStorage.removeItem('refreshTokenManu');
            localStorage.removeItem('CompanyInfo');
            window.checkIsLoggedIn({
              isLoggedIn:false,
              accessToken:null,
              refreshToken:null,
            });
            router.push('/signin');

            return true;
        },
        /*
        
        웹에서 로그인 상태 앱으로 보냄(webToApp)
        
        */
        checkIsLoggedIn: (data) => {
            const userAgent = navigator.userAgent.toLowerCase();
            console.log(`checkIsLoggedIn, 디바이스: ${userAgent}, 수신 값: ${JSON.stringify(data)}`)
            if (userAgent.indexOf('android') !== -1) {
                //안드로이드
                if (typeof WebViewBridge !== 'undefined' && WebViewBridge) {
                    WebViewBridge.checkIsLoggedIn(JSON.stringify(data));
                } else {
                    console.log('WebViewBridge does not exist');
                }
            } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
                // ios
                if (window.webkit?.messageHandlers && window.webkit?.messageHandlers?.checkIsLoggedIn) {
                    window.webkit.messageHandlers.checkIsLoggedIn.postMessage(data);
                }
            } else { 
                //기타
                window.opener?.postMessage(JSON.stringify(data));
            }
        },
        
        //MARK: webToApp_TEST
        /*
        data = { key0: 'valueString0', key1: 12345, key2: false }
        */
        requestWebToApp_TEST: (data) => {

            console.log(`bridges requestWebToApp_TEST method BEGIN`);

            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    console.log(`${key}: ${data[key]}`);
                }
            }

            const userAgent = navigator.userAgent.toLowerCase();

            //aos는 반드시 stringfy를 해서 보내야 하나...그게 맞았떤 걸로 기억하는데...
            console.log(`bridges requestWebToApp_TEST method \n 디바이스: ${userAgent}, 수신 값: ${JSON.stringify(data)}`);

            if (userAgent.indexOf('android') !== -1) {

                console.log('bridges requestWebToApp_TEST aos');

                //안드로이드
                if (typeof WebViewBridge !== 'undefined' && WebViewBridge) {
                    WebViewBridge.requestWebToApp_TEST(JSON.stringify(data));
                } else {
                    console.log('bridges requestWebToApp_TEST does not exist');
                }
            } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {

                console.log('bridges requestWebToApp_TEST ios');

                // ios
                if (window.webkit?.messageHandlers && window.webkit?.messageHandlers?.requestWebToApp_TEST) {
                    window.webkit.messageHandlers.requestWebToApp_TEST.postMessage(data);
                }
            } else { 

                console.log('bridges requestWebToApp_TEST else unknown');

                //기타
                window.opener?.postMessage(data);
            }

            console.log(`bridges requestWebToApp_TEST method END`);
        },

        //MARK: appToWeb_TEST
        /*
        data = { key0: 'valueString0', key1: 12345, key2: false }
        */
        requestAppToWeb_TEST: (data) => {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    console.log(`${key} : ${data[key]}`);
                }
            }

            const userAgent = navigator.userAgent.toLowerCase();
            console.log(`bridges requestAppToWeb_TEST method \n 디바이스: ${userAgent}, 수신 값: ${JSON.stringify(data)}`);

            if (userAgent.indexOf('android') !== -1) {
                //안드로이드
                console.log('bridges requestWebToApp_TEST aos called');
            } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
                // ios
                console.log('bridges requestAppToWeb_TEST ios called');
            } else { 
                //기타
                console.log('bridges requestAppToWeb_TEST else unknown');
            }
        },
    }
}
